import React, { useState, useEffect, useRef, useContext } from 'react'
import classNames from 'classnames'
import { Spacer, Field, Button, Label, Divider, Checkbox, Card, Icon, Row, Col, Collapse } from '@cleartrip/bento'
import Modal from 'lib/Modal'
import ModalHeader from '../UserProfileModalHeader'
import Dropdown from 'components/Dropdown'
import langTranslate from 'locale'
import OfflineToast from 'components/GlobalNav/UserProfile/offlineToast'

import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/logPageLoadEvents'
import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg'
import { ReactComponent as Visible } from 'assets/icons/visibility.svg'
import { ReactComponent as VisibleOff } from 'assets/icons/visibility-off.svg'
import { ReactComponent as SuperCoins } from 'assets/icons/SuperCoins.svg'
import { ReactComponent as SellDesign } from 'assets/icons/sell.svg'
import { ReactComponent as AccountCircleDesign } from 'assets/icons/account_circle.svg'
import { ReactComponent as PhoneSvg } from 'assets/icons/phone.svg'
import ModalHeaderNew from '../UserProfileModalHeaderNew';
import { ReactComponent as WalletLogin } from "assets/icons/WalletLogin.svg"
import { ReactComponent as OffersLogin } from "assets/icons/OffersLogin.svg"
const isRtl = process.env.CONTENT_DIR === 'RTL'

function SignInBlockNew({
    animatedClass,
    toggle,
    signInError,
    validateEmailHandler,
    changeEmailHandler,
    isEmailValid,
    email,
    validatePasswordHandler,
    changePasswordHandler,
    isPasswordValid,
    password,
    spanClass,
    checkboxClass,
    rememberCheckedStatus,
    setRememberCheckedStatus,
    checkBoxTextClass,
    onContinue,
    errorInfo,
    urlParam,
    resultsData,
    itineraryData,
    pagePath,
    clickHandler,
    handleLinkClick,
    setPageName,
    signInPasswordType,
    setSignInPasswordType,
    isLoading,
    showCloseButton
}) {
    const animationDefaultState = { isAnimate: false, direction: 'right', isFadeIn: false }
    const [animationParams, setAnimationParams] = useState(animationDefaultState)
    const animatedClassNew = classNames({
        'slide-in-right': animationParams.direction === 'right' && animationParams.isAnimate,
        'slide-in-left': animationParams.direction === 'left' && animationParams.isAnimate,
        'pxNew-8': 'pxNew-8'
    })
    const bannerAnimationRef=useRef();

    useEffect(()=>{
        let OutsideClickHandler=(event)=>{
            if(!bannerAnimationRef.current.contains(event.target)) {
                toggle();
           }
        }
        document.addEventListener("mousedown",OutsideClickHandler);
        return ()=>{
            document.removeEventListener("mousedown",OutsideClickHandler);
        }
    })

    return (
        <>
          
        <div  ref={bannerAnimationRef} className="d-flex">
          <div
            className="o-hidden d-flex flex-column brLogin-4"
            style={{
                width: '410px',
                height: '437px'
            }}
        >
            <img src="https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_410,h_437,dpr_2/offermgmt/bbdJson/Desktop_Banner.png" className='h-100'/>   
        </div>
            <div
                className="bg-white  o-hidden d-flex flex-column brLoginNew-4"
                style={{
                    width: '400px',
                    height: '437px'
                }}
            >
                <div
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            onContinue()
                        }
                    }}
                    className={animatedClass}
                >
                    <ModalHeaderNew toggle={toggle} showCloseButton={showCloseButton} />
                    <div className=" px-8 nmx-8" style={{ maxHeight: '368px' }}>
                        <OfflineToast page="sign in" />
                        {signInError && (
                            <>
                                <div className="py-2 px-2 h-8 flex flex-middle bg-error-600 c-white fs-2 br-4 ">
                                    <InfoIcon className="c-white" height={16} width={16} />
                                    <span data-testid="signinError" className={errorInfo}>
                                        {langTranslate(signInError)}
                                    </span>
                                </div>
                                <Spacer className="pt-8" />
                            </>
                        )}

                        <Field
                            placeholder={langTranslate('Enter registered email address')}
                            onBlur={validateEmailHandler}
                            onChange={changeEmailHandler}
                            hasError={!isEmailValid}
                            value={email}
                            data-testid="email"
                        />
                        {!isEmailValid && (
                            <div data-testid="invalidEmailMessage" className="c-error-500 fs-2 mt-1">
                                {langTranslate('Please enter a valid email address')}
                            </div>
                        )}
                        <Spacer className="pt-4" />
                        <div className="p-relative">
                            <Field
                                placeholder={langTranslate('Enter password')}
                                type={signInPasswordType ? 'password' : 'text'}
                                onBlur={validatePasswordHandler}
                                onChange={changePasswordHandler}
                                hasError={!isPasswordValid && password.length === 0}
                                value={password}
                                data-testid="password"
                            />
                            {!isPasswordValid &&
                                (password.length === 0 && (
                                    <div data-testid="invalidPassword" className="c-error-500 fs-2 mt-1">
                                        {langTranslate('Password cannot be left blank')}
                                    </div>
                                ))}
                            <span className={spanClass} onClick={() => setSignInPasswordType(!signInPasswordType)}>
                                {signInPasswordType ? <Visible /> : <VisibleOff />}
                            </span>
                        </div>

                        <Spacer className="pt-3" />
                        <div className="p-relative">
                            <Checkbox
                                className={checkboxClass}
                                checked={rememberCheckedStatus}
                                onClick={() => setRememberCheckedStatus(!rememberCheckedStatus)}
                            >
                                <span className={checkBoxTextClass}>{langTranslate('Keep me logged in')}</span>
                            </Checkbox>
                            <span
                                data-testid="forgot"
                                onClick={() => {
                                    ClevertapEvent({
                                        actionName: 'forgot_pwd',
                                        actionType: 'Button',
                                        page: 'flights_sign_in',
                                        urlParam,
                                        resultsData,
                                        itineraryData,
                                        currentPage: pagePath
                                    })
                                    clickHandler(USER_PROFILE_PAGE_CONTANTS.RESET_PAGE, true)
                                }}
                                className="fs-2 c-secondary-500 c-pointer hover:td-underline p-absolute h-9 flex  r-2 fw-500 t-0"
                            >
                                {langTranslate('Forgot password?')}
                            </span>
                        </div>

                        <Spacer className="pt-3" />

                        <Spacer className="pt-3" />
                        <div className="p-relative ptNew-9">
                            <Button full type="secondary" size="md" busy={isLoading} onClick={() => onContinue()}>
                                <span className="fs-3 fw-550"> {langTranslate('Log in')}</span>
                            </Button>

                            <Spacer className="ptNew-18" />

                            <div class="d-flex flex-center flex-middle">
                                <div class="d-block bb bc-grey-10 flex-1 " style={{ maxWidth: '28px' }}></div>
                                <p class=" mr-2 ml-2 fs-2  c-grey-40">or</p>
                                <div class="d-block bb bc-grey-10 flex-1" style={{ maxWidth: '28px' }}></div>
                            </div>

                            <Spacer className="ptNew-18" />
                            <Button
                                full
                                outline
                                type="secondary"
                                size="md"
                                onClick={() => setPageName(USER_PROFILE_PAGE_CONTANTS.SIGNIN_PAGE)}
                            >
                                <span className="d-flex flex-middle flex-center">
                                    <div>
                                        <PhoneSvg />
                                    </div>
                                    <div className="ml-1 fs-3 fw-500">{'Continue with Mobile'}</div>
                                </span>
                            </Button>
                        </div>
                        {/* <Divider text="or" />
                <Spacer className="pt-5" />
                <div className="h-9 px-4 ba bc-neutral-100 br-4 c-neutral-700 fs-2 bw-1 ta-center hover:bc-secondary-500 t-all flex flex-middle flex-center c-pointer">
                    <FbLogo height={18} width={18} />
                    <span onClick={() => facebookLogin()} className="fs-2 fw-500 c-neutral-900 pl-4">
                        {langTranslate('Sign in with facebook')}
                    </span>
                </div> */}
                        <Spacer className="pt-6" />
                        <Divider />

                        <div className="mt-4 d-flex flex-column flex-middle">
                            <div style={{ direction: isRtl ? 'rtl' : '' }}>
                                <span className="c-neutral-700 fs-2">
                                    {langTranslate("By continuing in, you agree to Cleartrip's ")}
                                </span>
                                <span
                                    style={isRtl ? { marginRight: '-2px' } : {}}
                                    className="c-secondary-500 fw-500 fs-2 hover:td-underline c-pointer"
                                    onClick={() => handleLinkClick('privacy-policy')}
                                >
                                    {langTranslate('privacy policy')}
                                </span>
                                <span className="c-neutral-700 fs-2">{langTranslate(' & ')}</span>
                                <span className="d-flex flex-center ">
                                    <span
                                        className="c-secondary-500 fw-500 fs-2 hover:td-underline c-pointer"
                                        onClick={() => handleLinkClick('terms-of-service')}
                                    >
                                        {langTranslate('terms of use ')}
                                    </span>
                                    <span className="c-neutral-700 fs-2">{langTranslate('.')}</span>
                                </span>
                            </div>
                        </div>
                        <Spacer className="pt-5" />
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default SignInBlockNew
